import { render, staticRenderFns } from "./AuthorsHighlight.vue?vue&type=template&id=2b16e7c1"
import script from "./AuthorsHighlight.vue?vue&type=script&lang=js"
export * from "./AuthorsHighlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports